import { render, staticRenderFns } from "./ArchivePage.vue?vue&type=template&id=4afa8b1d&"
import script from "./ArchivePage.vue?vue&type=script&lang=js&"
export * from "./ArchivePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports